module.exports = __webpack_public_path__ + "logo_311-06c047b40a22e617198f5abcd6a6b921.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_311.png
// module id = 1134
// module chunks = 0 1